export * from './switch.component';
export * from './switch.directive';
export * from './switch.module';
